import _ from 'underscore';
import { include } from 'underscore.string';
import { AggregateLength } from './aggregate-length';

/**
 * define Object SideBarOption
 * @typedef {Object} SideBarOption
 * @property {String[]} properties - list of property for sidebar
 * @property {Backbone.View} view - the view of sidebar
 */

/**
 * define Object SideBarOptionObject
 * @typedef {Object} SideBarOptionObject
 * key is properties joined by ','
 * value is SideBarOption
 */

/**
 * generate a list of aggregate length options
 * @private
 * @param {JsonSchema} schema - entity define schema
 * @returns {SideBarOption[]} - return a list of SideBarOption,
 * each item correspond to a aggregate length constraint
 */
function aggregateLengthGenerator(schema) {
  const aggregateLengthConstraints = _.filter(schema.constraints, { type: 'aggregateLength' });

  return _.map(aggregateLengthConstraints, constraint => ({
    properties: constraint.properties,
    view: AggregateLength,
  }));
}

const generators = {
  aggregateLength: aggregateLengthGenerator,
};

/**
 * convert sidebar list to a object indexed by sidebar string properties
 * @private
 * @param {SideBarOption[]} arraySidebars - list of sidebar options
 * @param {String} strProperties - properties joined by ','
 * @returns {SideBarOptionObject} return SideBarOptionObject
 */
function internalConvert(arraySidebars, strProperties) {
  return _.indexBy(arraySidebars, (sidebar) => {
    const strSidebarProperties = sidebar.properties.toString();

    if (!include(strProperties, strSidebarProperties)) {
      throw new Error(`Some of properties ${strSidebarProperties} passed in through sidebars are not in passed in properties ${strProperties}`);
    }

    return strSidebarProperties;
  });
}

/**
 * generate sidebar options by schema
 * @private
 * @param {JsonSchema} schema - entity schema define
 * @param {String[]} properties - list of property
 * @returns {SideBarOptionObject} - return SideBarOptionObject
 */
function bySchema(schema, properties) {
  const arraySidebars = _.reduce(generators, (memo, generator) =>
    memo.concat(generator(schema)), []);

  return internalConvert(arraySidebars, properties.toString());
}

/**
 * generate sidebar option for properties
 * @private
 * @param {JsonSchema} schema - entity define schema
 * @param {String[]} properties - property list used in form
 * @param {SideBarOption[]} sidebars - customized sidebar option list
 * @returns {SideBarOptionObject} - return SideBarOptionObject
 */
export function generateSidebarsOptions({ schema, properties, sidebars }) {
  const strProperties = properties.toString();

  return _.defaults(
    internalConvert(sidebars, strProperties),
    bySchema(schema, properties)
  );
}
